export default "__VITE_ASSET__DNEEGwft__"